import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Button, Input, Modal } from 'antd';
import {
  LinkedinShareButton,
  LinkedinIcon,
  FacebookShareButton,
  FacebookIcon,
  TelegramShareButton,
  TelegramIcon,
  TwitterShareButton,
  TwitterIcon,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
} from 'react-share';
import { CopyOutlined } from '@ant-design/icons';
import { shareMessages } from '../TourstartAcademy/components/share';
import { openNotificationWithIcon } from '../../Utility/notificationMessage';

function ShareTour({ tourUrl, type = 'tour', shown, cancel }) {
  const intl = useIntl();

  const text = {
    notification: intl.formatMessage(shareMessages.notification),
    emailSend: intl.formatMessage(shareMessages.emailSend),
    sent: intl.formatMessage(shareMessages.sent),
    notificationSend: intl.formatMessage(shareMessages.notificationSend),
    success: intl.formatMessage(shareMessages.success),
    error: intl.formatMessage(shareMessages.error),
    copied: intl.formatMessage({ id: 'Copied', defaultMessage: 'Copied' }),
  };

  const getUrl = () => {
    const url = process.env.SERVER_URL;
    return `${url}/${type}/${tourUrl}`;
  };

  return (
    <Modal
      centered
      visible={shown}
      footer={false}
      closable
      maskClosable
      onCancel={() => cancel()}
      className="academy_share"
      title={intl.formatMessage({ id: 'Share', defaultMessage: 'Share' })}
    >
      <div>
        <div className="share_icons">
          <div className="share_icon_item">
            <FacebookShareButton url={getUrl()}>
              <FacebookIcon size={44} round />
              <span>Facebook</span>
            </FacebookShareButton>
          </div>
          <div className="share_icon_item">
            <FacebookMessengerShareButton
              url={getUrl()}
              appId="1587425094819221"
            >
              <FacebookMessengerIcon size={44} round />
              <span>Messenger</span>
            </FacebookMessengerShareButton>
          </div>
          <div className="share_icon_item">
            <LinkedinShareButton url={getUrl()}>
              <LinkedinIcon size={44} round />
              <span>Linkedin</span>
            </LinkedinShareButton>
          </div>
          <div className="share_icon_item">
            <TelegramShareButton url={getUrl()}>
              <TelegramIcon size={44} round />
              <span>Telegram</span>
            </TelegramShareButton>
          </div>
          <div className="share_icon_item">
            <TwitterShareButton url={getUrl()}>
              <TwitterIcon size={44} round />
              <span>Twitter</span>
            </TwitterShareButton>
          </div>
        </div>
        <div>
          <div className="title">
            <FormattedMessage id="Page Link" defaultMessage="Page Link" />
          </div>
          <div className="copy_link">
            <Input value={getUrl()} disabled />
            <CopyToClipboard
              text={getUrl()}
              onCopy={() => {
                openNotificationWithIcon(text?.notification || text.copied);
              }}
            >
              <Button>
                <CopyOutlined />
              </Button>
            </CopyToClipboard>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default ShareTour;
